<template>
    <div class="news" style="display: table-cell;vertical-align: middle;text-align: center">
        <!-- ============= 顶部背景图 ============= -->
        <div>
            <img src="../../assets/images/news/banner.png" style="width: 100%;display: block">
        </div>

        <!-- ============= 信息更新列表标题 ============= -->
        <div class="news-title">
            <el-input v-model="news_search" placeholder="输入关键字搜索" style="width: 240px;margin-left: 10px"></el-input>
            <el-button type="primary" style="width: 120px;" @click="getNews()">搜索</el-button>
        </div>

        <!-- ============= 信息更新列表内容 ============= -->
        <div class="news-table"   style="display: inline-block;text-align: left">
            <el-row :gutter="24">
                <!-- 更新列表右侧表格 -->
                <el-col span="16">
                    <div style="margin-left: 120px;margin-top: 40px">
                        <el-table :data="jobTabledata" style="width: 720px">
                            <el-table-column  prop="title" >
                                <template slot="header">
                                    <span style="font-size: 16px;color: #fff">标题</span>
                                </template>
                                <template slot-scope="scope">
                                    <span class="wtq_hover" style="cursor: pointer;" :onclick="'window.location=\'showvalue?id='+scope.row.id+'\''" v-html="scope.row.title"></span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="date">
                                <template slot="header">
                                    <span style="font-size: 16px;color: #fff">更新日期</span>
                                </template>

                            </el-table-column>
                        </el-table>

                        <div class="news-pages"  style="margin-top: 40px;">
                            <el-pagination
                             @current-change="change_page"
                             @size-change="change_size"
                              :pagesize="show"
                              background
                              :current-page="page"
                              :page-count="page"
                              layout="prev, pager, next,sizes,jumper"
                              :total="total"
                              hide-on-single-page>
                            </el-pagination>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import api from '@/http/request'
    export default {
        data() {
            return {
                page: 1, // 当前页码
                total: 0, // 总条数
                allPage: 0, // 总条数
                show: 10, // 当前每页显示条数
                jobTabledata: [],
                
                
                news_search:'',
                type_id:'70',
            }
        },
        mounted:function(){
            let type_id=this.get_get_val('type_id');
            if(type_id){
                this.type_id=type_id;
            }
            this.getNews();
        },
        methods: {
            change_page(val){
                this.page=val;
                this.getNews();
            },
            change_size(val){
                this.show=val;
                this.getNews();
            },
            getNews () { // 获取信息列表
                let _this = this;
                //获取GET的值
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/file_go_show?type=2&new_type_id='+this.type_id+'&page='+this.page+'&show='+this.show+'&news_search='+this.news_search+'&type_id='+this.type_id,
                }).then((response) =>{
                    this.jobTabledata = response.data.news
                    this.page  = response.data.page_msg.page
                    this.allPage  = response.data.page_msg.allPage
                    this.total  = response.data.page_msg.show * response.data.page_msg.all_page
                    this.show  = response.data.page_msg.show
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            handleNodeClick(data) {
                console.log(data);
            },
            reload:function () {
                window.location.reload();
            },
            get_get_val:function (get_name){
                // 获取参数type_id的值
                var reg = new RegExp("(^|&)" + get_name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null){
                    return decodeURI(r[2]);
                }else{
                    return '';
                }
            },
            go_news:function (){
                alert(123)
            }
        }
  };
</script>

<style >
    .news th { background-color:  rgba(108,152,255,1) !important; }
    .news .news-title { line-height: 200px;height: 120px }
    .news .title-span { font-size: 36px;color: rgba(51,51,51,1); }
    .news .news-table { padding: 20px;/*height: 720px*/ }
    .news .article-item { margin-top: 40px;font-size: 14px }
    .news  .title-select { margin-left: 15%;line-height: 0px;width: 240px }
    .news .title-Data { margin-top: 40px; }
    .news .table-content { margin-top: 25px;font-size: 14px;cursor: pointer }
    
    .wtq_hover:hover{color: #6190cd;}
</style>



// WEBPACK FOOTER //
// src/pages/tools/showhtml.vue